// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"e0052fb1","92":"b52c84cb","149":"439a4ced","292":"c0767b3f","329":"a424e0ab","432":"7018fffc","456":"0d83cfa9","579":"c5e61903","624":"ff312666","655":"23af448f","920":"3dceaab9","944":"4ae3f9da"}[chunkId] + ".chunk.js";
};